<div class="page-header">
  <h1 class="page-title">Kampanjer</h1>
  <mat-divider></mat-divider>
</div>

<div class="table-container">
  <mat-toolbar>
    <a mat-flat-button
       color="accent"
       [routerLink]="['/campaigns/create']">
      <mat-icon class="mr-2"
                inline="true">add</mat-icon>Skapa
    </a>
  </mat-toolbar>
  <table mat-table
         [dataSource]="dataSource"
         class="table-hover"
         matSort
         matSortActive="id"
         matSortDirection="desc">

    <ng-container matColumnDef="id">
      <th mat-header-cell
          *matHeaderCellDef
          mat-sort-header> ID. </th>
      <td mat-cell
          *matCellDef="let campaign"> {{campaign.id}} </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell
          *matHeaderCellDef
          mat-sort-header> Namn </th>
      <td mat-cell
          *matCellDef="let campaign"> {{campaign.name}} </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell
          *matHeaderCellDef
          mat-sort-header> Kampanjtyp </th>
      <td mat-cell
          *matCellDef="let campaign"> {{CampaignTypeTranslations[campaign.type]}} </td>
    </ng-container>

    <ng-container matColumnDef="slotsCount">
      <th mat-header-cell
          *matHeaderCellDef
          mat-sort-header> Antal slots </th>
      <td mat-cell
          *matCellDef="let campaign">
        <span *ngIf="campaign.slots?.length">
          {{campaign.slots.length}} st
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell
          *matHeaderCellDef
          class="actions-col"></th>
      <td mat-cell
          *matCellDef="let campaign"
          [style.width]="'1px'">
        <button mat-icon-button
                (click)="onDeleteClick($event, campaign)"
                class="delete-button"
                aria-label="delete item">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row
        *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row
        *matRowDef="let campaign; columns: displayedColumns;"
        [routerLink]="['/campaigns', campaign.id]"></tr>
  </table>
</div>
